
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

import store from './store';

import VueTheMask from 'vue-the-mask';
import Selectize from 'vue2-selectize';

Vue.use(VueTheMask);
Vue.component('selectize', Selectize);

Vue.component('csrf', require('@/components/elements/csrf'));
Vue.component('relative-date', require('@/components/elements/RelativeDate'));
Vue.component('nothing-here', require('@/components/elements/NothingHere'));
Vue.component('date-picker', require('@/components/elements/form/DatePicker'));
Vue.component('photo-upload', require('@/components/elements/form/PhotoUpload'));
Vue.component('tutorials', require('@/components/layouts/Tutorials'));
Vue.component('messages', require('@/components/layouts/Messages'));
Vue.component('site-notices', require('@/components/layouts/SiteNotices'));
Vue.component('person-name', require('@/components/elements/PersonName'));

Vue.component('dashboard', require('@/components/dashboard/Dashboard'));
Vue.component('modals', require('@/components/modals/Modals'));
Vue.component('child-selector', require('@/components/layouts/ChildSelector'));
Vue.component('kid-mode-menu-button', require('@/components/layouts/KidModeMenuButton'));
Vue.component('exit-kid-mode-selector', require('@/components/layouts/ExitKidModeSelector'));
Vue.component('now-viewing-child', require('@/components/layouts/NowViewingChild'));
Vue.component('card-form', require('@/components/billing/CardForm'));
Vue.component('outcome-list', require('@/components/tracker/OutcomeList'));
Vue.component('delete-button', require('@/components/elements/DeleteButton'));
Vue.component('add-stamps', require('@/components/passport/AddStamps'));
Vue.component('ledger-items', require('@/components/passport/LedgerItems'));
Vue.component('ledger-item-description', require('@/components/passport/LedgerItemDescription'));
Vue.component('ledger-item-value', require('@/components/passport/LedgerItemValue'));
Vue.component('awards-list', require('@/components/passport/AwardsList'));
Vue.component('redeem-award', require('@/components/passport/RedeemAward'));
Vue.component('behaviors', require('@/components/tracker/Behaviors'));
Vue.component('behavior-log', require('@/components/tracker/BehaviorLog'));
Vue.component('create-behavior-log', require('@/components/tracker/CreateBehaviorLog'));
Vue.component('resource-list', require('@/components/resources/ResourceList'));

Vue.component('settings-children-list', require('@/components/settings/children/ChildrenList'));
Vue.component('add-child', require('@/components/settings/children/AddChild'));
Vue.component('edit-child', require('@/components/settings/children/EditChild'));
Vue.component('connection-list', require('@/components/settings/connections/ConnectionList'));
Vue.component('billing-overview', require('@/components/billing/BillingOverview'));
Vue.component('manage-card-form', require('@/components/billing/ManageCardForm'));
Vue.component('manage-billing', require('@/components/billing/ManageBilling'));

// Sign Up & Login
Vue.component('create-account-form', require('@/components/signup/CreateAccountForm'));
Vue.component('create-another-account-form', require('@/components/signup/CreateAnotherAccountForm'));

// Sales menu
Vue.component('menu-button', require('@/components/sales/MenuButton'));

const app = new Vue({

    store,

    mounted() {

        $('#open-kid-mode').click((e) => {
            e.preventDefault();
            this.$root.$emit('kid-mode-modal');
        });

        $('#exit-kid-mode').click((e) => {
            e.preventDefault();
            this.$root.$emit('exit-kid-mode');
        });
    },

    data() {
        return {
            menuOpen: false,
        };
    },

    watch: {

        menuOpen: function() {
            this.checkMenuOpen();
        },

    },

    methods: {

        checkMenuOpen() {
            $('body').removeClass('menu-open');
            if (this.menuOpen) {
                $('body').addClass('menu-open');
            }
        },

    },

    el: '#app'
});

$('a.menu').click((e) => {
    e.preventDefault();
    $('nav, .menu-underlay').addClass('active');
});

$('nav, .menu-underlay').click(e => {
    $('nav, .menu-underlay').removeClass('active');
});

$('.selectize').not('.create').selectize();
$('.selectize.create').selectize({ create: true });

$(document).ready(function() {
    $('form').on('submit', function() {
        $(this).find('.processable[type="submit"]').removeClass('good-bg').addClass('neutral-bg').text('Processing...').prop('disabled', true);
    });
});


// WEBPACK FOOTER //
// ./resources/js/app.js